export const GLOBAL_CONSTANTS = {
  idToken: 'id_token',
  userCookieName: 'user',
  rememberMe: 'rememberMe',
  expiredTime: 'expiredTime',
  companyId: 'companyId',
};

export const ROUTE_PATH = {
  login: 'login',
  home: '',
};

export const AUTH_ENDPOINTS = {
  login: 'Login',
  renew_token: 'Login/tokens',
  logout: 'Logout',
};
